export var defaultProps = {
    prefixCls: 'statistic',
    className: '',
    decimalSeparator: '.',
    groupSeparator: ',',
};
